export default "__VITE_ASSET__ea9300ba__"